import { Box } from '@ltvco/refresh-lib/theme';
import { useRef, useState, useEffect, Children } from 'react';

export const MasonryCardsContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setWidth(entry.contentRect.width);
      }
    });

    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, []);

  const columnCount = Math.max(1, Math.floor(width / 500));
  const columns: React.ReactNode[][] = Array.from(
    { length: columnCount },
    () => []
  );
  Children.forEach(children, (child, index) => {
    columns[index % columnCount].push(child);
  });

  return (
    <Box
      ref={containerRef}
      style={{
        display: 'flex',
        gap: '16px',
        margin: '0 10px',
        paddingRight: '15px',
      }}
    >
      {columns.map((column, i) => (
        <Box
          key={i}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            flex: 1,
          }}
        >
          {column.map((child, j) => (
            <Box key={j}>{child}</Box>
          ))}
        </Box>
      ))}
    </Box>
  );
};
